import PropTypes from 'prop-types';
import './style.scss';
import { Sidebar } from 'components/common/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars,
  faArrowRightFromBracket,
  faXmark
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { Offcanvas } from 'react-bootstrap';
import { logout } from 'service/utilities';
import { Toast } from 'service/toast';
import { postLogoutAct } from 'redux/actions/requestFieldMasterSetupViewAction';

const LogoutApi = async () => {
  try {
    const res = await postLogoutAct();
    const { success, message } = res;
    if (success) {
      Toast({ type: 'success', message });
      logout();
    } else {
      Toast({ type: 'success', message });
    }
  } catch (err) {
    Toast({ type: 'error', message: 'An error occurred during logout.' });
  }
};

export const MobileSidebar = (props) => {
  const { mobileChildren, show, handleClose, handleShow } = props;

  return (
    <>
      {/* mobile sidebar layout */}
      <Offcanvas show={show} onHide={handleClose}>
        <div className="position-relative">
          <div className="closeIcon-mobile">
            <FontAwesomeIcon
              icon={faXmark}
              className="closeIcon"
              color="#fff"
              onClick={handleClose}
            />
          </div>
        </div>
        <Offcanvas.Header>
          <Offcanvas.Title />
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Sidebar isMobile />
        </Offcanvas.Body>
      </Offcanvas>
      <div className={`main-layout `}>
        <div className="d-flex justify-content-between align-items-center px-3 py-3 mobileNavbar">
          <div>
            <FontAwesomeIcon
              icon={faBars}
              className="mobileHambargerIcon"
              onClick={handleShow}
            />
          </div>
          <div>
            <div className="d-flex flex-row">
              {/* <div>
                <img
                  src={logo}
                  className="img-fluid mobileBarLogo pe-1"
                  alt="icon"
                />
              </div> */}
              <div>
                <Link to="/" className="mobile-logo-wrapper">
                  Anchor Lending
                </Link>
              </div>
            </div>
          </div>
          <div>
            <FontAwesomeIcon
              icon={faArrowRightFromBracket}
              className="mobileLogoutIcon"
              onClick={() => LogoutApi()}
            />
          </div>
        </div>
        <div className="main-layout-wrapper">
          <div className="mt-5 pt-5 px-4">{mobileChildren}</div>
        </div>
      </div>
    </>
  );
};

MobileSidebar.propTypes = {
  mobileChildren: PropTypes.node.isRequired,
  handleShow: PropTypes.func,
  handleClose: PropTypes.func,
  show: PropTypes.bool
};

MobileSidebar.defaultProps = {
  handleShow: () => null,
  handleClose: () => null,
  show: true
};
